import { Component, ErrorInfo, ReactNode } from "react";

interface props {
  children: ReactNode
}

interface state {
  hasError: boolean
}

class ErrorBoundary extends Component<props, state> {
  constructor(props: props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <div className="text-center text-danger fs-4">Something went wrong.</div>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;